import React, { useContext, useEffect } from "react";
import Movie from "./Movie";
import MovieContext from "../MovieContext";

import { motion } from "framer-motion";

const MoviesList = () => {
  // eslint-disable-next-line
  const { filtered, fetchPopular, header, setActiveGenre } =
    useContext(MovieContext);
   
  useEffect(() => {
    if (header === "Trending") {
      fetchPopular();
    }
    // eslint-disable-next-line
  }, [header]);



  return (
    <>
      <motion.div layout className="popular-movies">
        {filtered.map((movie) => {
          return <Movie key={movie.video_id} movie={movie} />;
        })}
      </motion.div>
      {filtered.length === 0 && <p className="info">No movies to display</p>}
    </>
  );
};

export default MoviesList;
